import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { HiOutlineDownload } from "react-icons/hi";
import HistoryService from "../../services/HistoryService";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import { operatorList } from "../../constants/Operators";
import { FaPhoneAlt, FaRupeeSign, FaExclamationCircle } from "react-icons/fa";
import RechargeService from "../../services/RechargeService";

const RechargeTab = (props) => {
  const { hideLoading } = props;
  const today = new Date().toISOString().split("T")[0];

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [searchText, setSearchText] = useState("");
  const [isInitState, setIsInitState] = useState(true);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    fetchData();
  }, [
    // fromDate, toDate, searchText,

    page,
    size,
  ]);

  const fetchData = async () => {
    if (hideLoading) setLoading(true);

    try {
      const result = await HistoryService.recharge(
        fromDate,
        toDate,
        searchText,
        isInitState,
        size,
        page
      );

      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      const responseData = result.data;
      if (responseData.status === "SUCCESS") {
        setData(responseData.data.result);
        setTotalRows(responseData.data.total_count || 0);
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire("Oops!", "Request Failed", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadReceipt = async (orderId) => {
    try {
      setLoading(true);
      const result = await RechargeService.downloadReceipt(orderId);

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Transaction failed", "error");
        setLoading(false);
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        const link = responseData.data?.link;
        if (link) {
          window.open(link, "_blank");
        }
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire("Oops!", error?.message || "Network error", "error");
    } finally {
      setLoading(false);
    }
  };

  const getOperatorCell = (operatorName) => {
    const operator = operatorList.find(
      (op) => op.title.toLowerCase() === (operatorName || "").toLowerCase()
    );

    return operator ? (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={operator.image}
          alt={operator.title}
          style={{
            width: "40px",
            height: "40px",
            objectFit: "contain",
            marginRight: "8px",
          }}
        />
        {/* <span style={{ fontWeight: "bold", fontSize: "15px" }}>
          {operator.title}
        </span> */}
      </div>
    ) : (
      <span>{operatorName}</span>
    );
  };

  const getStatusBadge = (status) => {
    switch (status?.toUpperCase()) {
      case "SUCCESS":
        return <span className="badge bg-success">{status}</span>;
      case "FAILED":
      case "REFUND":
        return <span className="badge bg-danger">FAILED</span>;
      case "PENDING":
        return <span className="badge bg-warning">{status}</span>;
      default:
        return <span className="badge bg-secondary">{status || "-"}</span>;
    }
  };

  const handleRaiseComplaint = async (orderId) => {
    setLoading(true);

    try {
      const result = await RechargeService.dispute(orderId);

      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      const responseData = result.data;
      if (responseData.status === "SUCCESS") {
        Swal.fire("Success!", responseData.message, "success");
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire("Oops!", "Request Failed", "error");
    } finally {
      setLoading(false);
    }
  };

  const getDisputeText = (status) => {
    switch (status) {
      case "PENDING":
        return { text: "Complaint Requested", className: "btn-warning" };
      case "REJECTED":
        return { text: "Complaint Request Rejected", className: "btn-danger" };
      case "ACCEPTED":
        return { text: "Complaint Request Accepted", className: "btn-success" };
      default:
        return { text: "Raise Complaint", className: "btn-danger" };
    }
  };

  return (
    <div>
      {/* {loading && <LoadingScreen />} */}

      {loading && (
        <div className="d-flex justify-content-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {/* Filter Toggle */}
      <div className="mb-3 text-end">
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => setShowFilters(!showFilters)}
        >
          {showFilters ? "Hide Filters" : "Show Filters"}
        </button>
      </div>

      {/* Filters */}
      {showFilters && (
        <div className="ps-3 pe-3 mb-3">
          <div className="row border p-3 rounded bg-light g-3">
            <div className="col-md-3">
              <label>From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => {
                  setFromDate(e.target.value);
                  setIsInitState(false);
                }}
              />
            </div>
            <div className="col-md-3">
              <label>To Date</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => {
                  setToDate(e.target.value);
                  setIsInitState(false);
                }}
              />
            </div>
            <div className="col-md-4">
              <label>Search</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search by Number, Order ID"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <button className="btn btn-primary w-100" onClick={fetchData}>
                Apply
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Table */}
      <div style={{ overflowX: "auto" }}>
        <table className="table table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Order ID</th>
              <th>Operator</th>
              <th>Number & Amount</th>
              <th>Cashback</th>
              <th>Operator TXN ID</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="9" className="text-center">
                  No records found
                </td>
              </tr>
            ) : (
              data.map((row, index) => (
                <tr key={row.order_id}>
                  <td>{(page - 1) * size + index + 1}</td>
                  <td>{row.created_on}</td>
                  <td>{row.order_id}</td>
                  <td>{getOperatorCell(row.product?.name)}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "15px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {row.optional1 || "-"}
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        ₹{row.order_amount || "0"}
                      </div>
                    </div>
                  </td>
                  <td
                    style={{
                      color: "green",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                  >
                    ₹{row.commercial_amount || "0"}
                  </td>
                  <td>{row.operator_id}</td>
                  <td>{getStatusBadge(row.status)}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "3px",
                      }}
                    >
                      {/* --- Receipt Button --- */}
                      <button
                        className="btn btn-success btn-xs"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px",
                          padding: "0.15rem 0.4rem",
                          fontSize: "0.7rem",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => handleDownloadReceipt(row.order_id)}
                      >
                        <HiOutlineDownload size={12} />
                        Receipt
                      </button>

                      {/* --- Dispute Button --- */}
                      {(() => {
                        const dispute = getDisputeText(row.secret_optional5);
                        return (
                          <button
                            className={`btn btn-xs ${dispute.className}`}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                              whiteSpace: "nowrap",
                              padding: "0.15rem 0.4rem",
                              fontSize: "0.7rem",
                            }}
                            onClick={() => handleRaiseComplaint(row.order_id)}
                          >
                            <FaExclamationCircle size={12} />
                            {dispute.text}
                          </button>
                        );
                      })()}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalRows > size && (
        <div className="d-flex justify-content-between align-items-center mt-2">
          <div>
            Showing {(page - 1) * size + 1} - {Math.min(page * size, totalRows)}{" "}
            of {totalRows}
          </div>
          <div>
            <button
              className="btn btn-outline-secondary btn-sm me-2"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Previous
            </button>
            <button
              className="btn btn-outline-secondary btn-sm"
              disabled={page * size >= totalRows}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RechargeTab;
